export const FeatureFlagMetricName = {
  SEARCH_GLOBAL: 'up_global_search_bar',
  SEARCH_ITEM_CLICK: 'up_search_item_click',
  SEARCH_ITEM_ENROLL: 'up_search_item_enroll',
  SEARCH_ITEM_FAVORITE: 'up_search_item_favorite',
  SEARCH_ZERO_RESULT: 'up_search_zero_result'
} as const

/**
 * Type helper for TypeScript
 */
export type FeatureFlagMetricNameType = typeof FeatureFlagMetricName
